<template>
  <div class="view pa24" :key="i18nUpdateKey">
    <div class="d-flex">
      <div>
        <el-input
          class="w120 mb10 mr10"
          :placeholder="$t('merchandise', 'categoryName')"
          v-model="filterName"
        />
        <el-button type="primary" @click="filterNames">{{ $t('common', 'search') }}</el-button>
      </div>
      <div style="margin-left: auto">
        <!-- <el-button class="ma mr10 mb10" @click="delAll">批量删除</el-button> -->
        <el-button class="ma" type="primary" @click="open"
          >+ {{ $t('merchandise', 'addCategory') }}</el-button
        >
      </div>
    </div>
    <commonTable
      :tableData="tableData"
      @handleSelectionChange="handleSelectionChange"
      :total="total"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      :currentPage="currentPage"
      :loading="loading"
    >
      <template v-slot:table>
        <!-- <el-table-column type="selection" /> -->
        <el-table-column prop="goodstypeId" align="center" :label="$t('merchandise', 'categoryNumber')" />
        <el-table-column prop="name" align="center" :label="$t('merchandise', 'categoryName')" />
        <el-table-column prop="goodsNum" align="center" :label="$t('merchandise', 'goodsCount')" />
        <el-table-column prop="dealNum" align="center" :label="$t('merchandise', 'totalSales')" />
        <el-table-column prop="" align="center" :label="$t('merchandise', 'sort')">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('merchandise', 'categorySortTip')" placement="top-start">
              <el-input v-model="scope.row.sort" :placeholder="$t('merchandise', 'categorySortTip')" @change="saveSort(scope.row)"/>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('common', 'edit')">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="open(scope.row)"
              >{{ $t('merchandise', 'edit') }}</el-button
            >
            <customPopconfirm
              class="ma ml10 mb10"
              :confirm-button-text="$t('common', 'confirm')"
              :cancel-button-text="$t('common', 'cancel')"
              @confirm="del(scope.row)"
              :title="$t('merchandise', 'confirmDelete')">
              <el-button type="danger" slot="reference" plain>{{ $t('merchandise', 'delete') }}</el-button>
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
// @ts-ignore
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
// @ts-ignore
import {
  getGoodsTypeInfo,
  selectGoodsTypeInfoPC,
  addGoodsType,
  delGoodsType,
  updateGoodsTypeSort
  // @ts-ignore
} from "@/api/coupon.js";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "productList",
  mixins: [i18nMixin],
  components: {
    commonTable,
    customPopconfirm
  },
  props:{
    jurisdiction:{
        type: Boolean,
        default: false,
    },
  },
  data() {
    return {
      userInfo: this.$store.state.loginRoot.userInfo,
      options: [{ label: this.$t('merchandise', 'all'), value: 1 }],
      tableData: [],
      filterName: "",
      row: "",
      delGoodsT: [],
      currentPage: 1,
      loading:false,
      total: 0, //总条数
      pageNum: 1,
      pageSize: 10,
    };
  },

  methods: {
    //分类弹窗
    open(row) {
      if(this.userInfo.roleId || this.jurisdiction){
        this.row = row.name;
      //新增
      if (!this.row) {
        this.$prompt(this.$t('merchandise', 'inputCategoryName'), {
          confirmButtonText: this.$t('common', 'confirm'),
          cancelButtonText: this.$t('common', 'cancel'),
        })
          .then(({ value }) => {
            addGoodsType({
              name: value,
              sort: 0,
              isDel: 0,
            })
            .then(res=>{
              
              this.$message({
                type: "success",
                message: this.$t('merchandise', 'addSuccess'),
                center: true,
              });
              this.get();
            })
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('merchandise', 'operationCancel'),
              center: true,
            });
          });
        } else {
          //编辑
          this.$prompt(this.$t('merchandise', 'inputCategoryName'), {
            confirmButtonText: this.$t('common', 'confirm'),
            cancelButtonText: this.$t('common', 'cancel'),
            inputValue: row.name,
          })
          .then(async ({ value }) => {
            addGoodsType({
              name: value,
              sort: row.sort,
              isDel: row.isDel,
              goodstypeId: row.goodstypeId,
            });

            this.$message({
              type: "success",
              message: this.$t('merchandise', 'editSuccess'),
              center: true,
            });
            this.get();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('merchandise', 'operationCancel'),
              center: true,
            });
          });
        }
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },
    handleSelectionChange(value) {
      this.delGoodsT = value;
    },
    //删除弹窗
    del(row) {
      if(this.userInfo.roleId || this.jurisdiction){
        delGoodsType({ goodstypeId: row.goodstypeId })
        .then(() => {
          this.$message({
            message: this.$t('merchandise', 'operationSuccess'),
            type: "success",
            center: true,
          });
          this.get();
        })
        .catch(() => {
          this.$message({
            message: this.$t('merchandise', 'operationFailed'),
            type: "warning",
            center: true,
          });
        });
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },

    //获取数据
    async get() {
      let data = {
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      this.loading = true;
      selectGoodsTypeInfoPC(data) //获取分类数据
      .then(res=>{
        this.loading = false;
        this.tableData = res.data.pageInfo.list;
        this.total = res.data.pageInfo.total
      })
      .catch(err=>{
        this.loading = false;
      })
    },
    //搜索
    async filterNames() {
      this.tableData = this.tableData.filter(
        (item) => this.filterName == item.name
      );
      if (this.filterName.length < 1) {
        this.get();
      }
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.loading = true;
      this.get();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.loading = true;
      this.get();
    },
    //全删除
    delAll() {
      this.delGoodsT.map((itme) => {
        delGoodsType({ goodstypeId: itme.goodstypeId });
      });
      if (this.delGoodsT.length > 0) {
        this.$message({
          message: this.$t('merchandise', 'operationSuccess'),
          type: "success",
          center: true,
        });
      }
      this.delGoodsT = [];
      this.get();
    },
    async saveSort(row){
      if(row && row.sort != ""){
        console.log(row)
        const result = await updateGoodsTypeSort(row);
        console.log("result:",result)
        this.$message({
          type: "info",
          message: this.$t('merchandise', 'saveSuccess'),
        });
      }else{
        this.$message({
          type: "error",
          message: this.$t('merchandise', 'sortCannotEmpty'),
        });
      }
    }
  },

  //生命周期
  async created() {
    this.get();
  },
  mounted() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>

<style lang="scss" scoped></style>
